/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SensorData } from './SensorData';
import {
    SensorDataFromJSON,
    SensorDataFromJSONTyped,
    SensorDataToJSON,
    SensorDataToJSONTyped,
} from './SensorData';

/**
 * Serializer for sensor data request status and results.
 * @export
 * @interface SensorDataRequest
 */
export interface SensorDataRequest {
    /**
     * 
     * @type {Array<SensorData>}
     * @memberof SensorDataRequest
     */
    responseData?: Array<SensorData> | null;
    /**
     * 
     * @type {string}
     * @memberof SensorDataRequest
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof SensorDataRequest
     */
    errorMessage?: string | null;
}

/**
 * Check if a given object implements the SensorDataRequest interface.
 */
export function instanceOfSensorDataRequest(value: object): value is SensorDataRequest {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function SensorDataRequestFromJSON(json: any): SensorDataRequest {
    return SensorDataRequestFromJSONTyped(json, false);
}

export function SensorDataRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SensorDataRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'responseData': json['response_data'] === undefined ? undefined : json['response_data'] === null ? null : ((json['response_data'] as Array<any>).map(SensorDataFromJSON)),
        'status': json['status'],
        'errorMessage': json['error_message'] === undefined ? undefined : json['error_message'] === null ? null : json['error_message'],
    };
}

export function SensorDataRequestToJSON(json: any): SensorDataRequest {
    return SensorDataRequestToJSONTyped(json, false);
}

export function SensorDataRequestToJSONTyped(value?: SensorDataRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'response_data': value['responseData'] == null ? undefined : ((value['responseData'] as Array<any>).map(SensorDataToJSON)),
        'status': value['status'],
        'error_message': value['errorMessage'],
    };
}

